/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamListElement = {
    properties: {
        officialName: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        internalName: {
            type: 'string',
            isRequired: true,
        },
        emblem: {
            type: 'Image',
            isRequired: true,
        },
        primaryColor: {
            type: 'string',
            isRequired: true,
        },
        secondaryColor: {
            type: 'string',
            isRequired: true,
        },
        leagues: {
            type: 'array',
            contains: {
                type: 'LeagueListElement',
            },
            isRequired: true,
        },
        jerseyColor1: {
            type: 'string',
            isRequired: true,
        },
        jerseyColor2: {
            type: 'string',
            isRequired: true,
        },
        jerseyMode: {
            type: 'JerseyModeEnum',
            isRequired: true,
        },
        club: {
            type: 'any-of',
            contains: [{
                type: 'ClubListElement',
            }, {
                type: 'null',
            }],
        },
        outOfCompetition: {
            type: 'boolean',
            isRequired: true,
        },
        matchBoard: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
    },
} as const;
